import { fillCourseTypeData } from '../default-course-list-data';
import { Api } from '@/constants';
import type { Info } from '@/models/bootstrap/info';
import { Features, type Plan } from '@/models/bootstrap/plan';
import type { KnowledgeArea } from '@/models/bootstrap/taxonomy';
import type { CourseType } from '@/models/catalog/course';
import type { User } from '@/models/user';

interface CourseTypesEntity {
  type: string;
  label: string;
}

interface CourseTypesWithLinkProps {
  plan?: Plan;
  courseTypes: CourseTypesEntity[];
  universityCard: CourseType | null;
  customCategory: string | undefined;
  info?: Info;
}

export const getUniversityCard = (user?: User): CourseType | null => {
  const label = user?.colaborador?.empresa?.corporate_university_name;
  const logo = user?.colaborador?.empresa?.logo;
  return label && logo
    ? {
        label,
        link: '/corporate_university/trilhas',
        image: `${Api.EdupassApi}/contents/categorias/${logo}`,
        description: '',
        type: 'university',
      }
    : null;
};

export const getCourseTypesWithLink = ({
  plan,
  courseTypes,
  universityCard,
  customCategory,
  info,
}: CourseTypesWithLinkProps) => {
  const cards = [];
  const baseUrl = 'https://assets.galena.com/edupass-api/public/home-banners';
  const cobrandedFeature = plan?.features?.filter(
    (item) => item.name === Features.Einstein
  );
  const unibradPos = plan?.features?.filter(
    (item) => item.name === Features.UnibradPos
  );
  const fullIncluded = plan?.features?.some(
    (el) => el.name === Features.FullIncluded
  );

  if (cobrandedFeature && cobrandedFeature.length > 0) {
    cards.unshift({
      description: 'Confira os cursos disponíveis',
      image: `${baseUrl}/einstein_catalog/banner-einstein-card.png`,
      label: 'Faculdade Einstein',
      link: '/cursos/?page=1&institutions=383',
    });
  }
  if (unibradPos && unibradPos.length > 0) {
    cards.unshift({
      description: 'Aproveite essa exclusividade da Unibrad.',
      image: `${baseUrl}/unialphaville-bradesco-nov-2024/Banner Card-M.png`,
      label: 'Pós-graduação UniBrad',
      link: '/cursos/?unibrad_included=true',
    });
  }
  if (universityCard) {
    cards.push({
      description: universityCard.description || '',
      image: universityCard.image || '',
      label: universityCard.label,
      link: universityCard.link,
    });
  }
  if (customCategory && info) {
    cards.push({
      description: 'Recomendados pela sua empresa',
      image: `${Api.EdupassApi}/contents/categorias/${info.colaborador.empresa.logo}`,
      label: customCategory,
      link: '/cursos/custom-category',
    });
  }
  if (fullIncluded) {
    const { description, image } = fillCourseTypeData('full');
    cards.push({
      label: 'Cursos Gratuitos',
      link: 'cursos/?free_courses=true',
      description,
      image,
    });
  }
  courseTypes.forEach((ct) => {
    const { description, image } = fillCourseTypeData(ct.type);
    cards.push({
      label: ct.label,
      link: `cursos?course_types=${ct.type}`,
      description,
      image,
    });
  });

  return cards;
};

export const getKnowledgeAreasWithLink = (
  knowledgeAreas: KnowledgeArea[]
): (KnowledgeArea & { link: string })[] => {
  return knowledgeAreas.map((knowledgeArea) => ({
    ...knowledgeArea,
    link: `cursos?knowledge_areas=${knowledgeArea.id}`,
  }));
};
